import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Subscribers from "@/pages/Subscribers";
import Tags from "@/pages/Tags";
import Events from "@/pages/Events";
import Programs from "@/pages/Programs";
import Broadcasts from "@/pages/Broadcasts";
import Admins from "@/pages/Admins";
import Settings from "@/pages/Settings";
import Layout from "@/components/Layout";

function Protected({ children }) {
  const { admin, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500 text-sm">
        Загрузка…
      </div>
    );
  if (!admin) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { admin, loading } = useAuth();
  if (loading) return null;
  if (admin) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route
              path="/login"
              element={
                <PublicOnly>
                  <Login />
                </PublicOnly>
              }
            />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="subscribers" element={<Subscribers />} />
              <Route path="tags" element={<Tags />} />
              <Route path="events" element={<Events />} />
              <Route path="programs" element={<Programs />} />
              <Route path="broadcasts" element={<Broadcasts />} />
              <Route path="admins" element={<Admins />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
